import React from 'react'
import { StyledImage, NativeLazyLoading } from './Image.web.styled'

export interface ImageProps {
    src: string
    srcSet?: string
    sizes?: string
    alt?: string
    enableFadeIn: boolean
    className?: string
    loading?: NativeLazyLoading
    onError?: () => void
}

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
    ({ enableFadeIn, src, srcSet, sizes, alt, className, loading, onError }, ref) => {
        const [loaded, setLoaded] = React.useState(enableFadeIn === false)
        function onLoad() {
            setLoaded(true)
        }

        return (
            <StyledImage
                ref={ref}
                show={loaded}
                onLoad={onLoad}
                onError={onError}
                src={src}
                srcSet={srcSet}
                sizes={sizes}
                alt={alt}
                className={className}
                loading={loading}
            />
        )
    }
)

Image.displayName = 'Image'
